<template>
	<div class="BillCorrection">
		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов найдено: {{this.masObjects_total}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="billing"
			/>
		</div>
		<card class="post mt-2 focus-shadow" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.PayMaster == 1">
			<!-- <div class="col-title">
				<h3 class="mb-0 mr-2">Корректировки.</h3> 
				<p>Для изменения баланса сотрудника по причинам. Для отрицательной корректировки поставьте перед суммой знак "-".</p>
			</div> -->
			<div class="py-3">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Внести корректировку</h5>
			</div>
			<div class="postAddForm" >		
				<form class="form-container">
					<div class="row justify-content-between align-items-center">  
							<div class="d-flex mb-3">
								<base-radio v-for="(el_opt, el_index) in correction_type.options" 
								:name="el_opt.value" 
								:label="el_opt.label" 
								:key="el_index"
								v-model="correction_type.value" 
								inline
								class="mt-0 ml-3">{{el_opt.label}}</base-radio>
							</div>
							<div class="col-md mb-3 mt-1">
								<re-input-amount v-model="cor_amount" mask="money" placeholder="Сумма" :positiveOnly="false" />
							</div>
							<div class="col-md mb-3">
							<ReInputSearchDrop
								:findId="'agent_id'"
								:placeholder="'Выбрать сотрудника'"
								v-model="cor_staff_code"
								:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
								@change="onAgentChange"
							/></div>
							<div class="col-md mb-3 mt-2">
								<base-input
								placeholder="Примечание"
								v-model="cor_comment"
								autocomplete="off"
								></base-input>
							</div>

						<div class="d-flex px-3 mb-3">
							<base-button type="success" simple @click="INS_CORRECT()"><i class="tim-icons icon-send mr-2"></i>{{ correctButtonText }}</base-button>
						</div>
					</div>
				</form>						
			</div>
		</card>

		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<h4 v-if="this.objApimsg && this.objApimsg!=''" class="text-center"> <i class="tim-icons icon-alert-circle-exc text-danger mb-2 mr-2"></i> {{this.objApimsg}}</h4>

			<el-table :data="CorrektirovkaApiData" style="width: 100%;" @sort-change="onSortChange" ref="CorrektirovkaTable">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
				>
				</el-table-column>
				<el-table-column 
					min-width="180"
					label="Сумма"
					property="amount"
				>
					<template v-slot="scope">{{ $GVO.number_format(scope.row.amount,0,'.',' ') }}</template>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="Сотрудник"
					property="staff_code"
					sortable
				>
					<!-- <template slot-scope="scope">
						<router-link :to="'/data/staff/id/'+scope.row.staff_code">{{scope.row.staff_code}}</router-link>
					</template> -->
					<template v-slot="scope">
						<router-link :to="'/data/staff/id/'+scope.row.staff_code" v-if="scope.row.staff_fio !=''">{{scope.row.staff_fio}}</router-link>
						<p v-else>{{scope.row.staff_code}}</p>
					</template>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="Кто провел операцию"
					property="acc_user"
				>
					<template v-slot="scope">
						<router-link :to="'/data/staff/id/'+scope.row.acc_user" v-if="scope.row.acc_user_fio !=''">{{scope.row.acc_user_fio}}</router-link>
						<p v-else>{{scope.row.acc_user}}</p>
					</template>
				</el-table-column>
				<el-table-column 
					min-width="180"
					label="Примечание"
					property="comment"
				>
				</el-table-column>
				<!-- <el-table-column 
					min-width="180"
					label="operation_type"
					property="operation_type"
				>
				</el-table-column> -->
				<el-table-column 
					min-width="180"
					label="Дата операции"
					property="dt_ins"
					sortable
				>
					<template v-slot="scope">{{ $GVO.convertDateTimeFromMysql(scope.row.dt_ins) }}</template>
				</el-table-column>
				
			
			</el-table>
		</card>	
		<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(count2page)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>

	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import Pagination from 'src/our_components/RePagination';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
// import ReInputMask from "src/our_components/ReInputMask.vue";
import swal from 'sweetalert2';
import ReInputAmount from '../our_components/ReInputAmount.vue';
import { BaseRadio  } from 'src/components/index';

export default {
	name: 'billcorrection-page',
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		[Button.name]: Button,
		Pagination,
		ReFilterBtn,
		ReFilter,
		ReInputSearchDrop,
		// ReInputMask,
		ReInputAmount,
		BaseRadio,
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		value: String,
	},
	data () {
		return {
			ver: 1,
			// bufferValue: '',
			CorrektirovkaApiData: [],
			objGetParams:{},
			objSortLoc:{order_field: 'dt_ins', sortOrder: 'descending'},
			masObjects_total: 0,
			count2page: 10,
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			cor_amount:'',
			cor_comment: '',
			cor_staff_code: {inputText: '', selectedVal:''},
			fullscreenLoading: false,
			objApimsg: '',
			correction_type: {value:'', elementType: 'correctionType', value_default: 0, options:[
				{value: 0, label: 'Пополнить'}, 
				{value: 1, label: 'Снять'},
			]},
		}
	},
	watch:{
		// value(val){
		// 	this.bufferValue = this.$GVO.unlinkObject(val);
		// },
		// bufferValue(val){
		// 	this.bufferValue = val;
		// 	this.$emit("input", this.bufferValue);
		// },
	},
	computed: {
		correctButtonText(){
			let opt = {0:'Начислить ',1:'Списать'}[this.correction_type.value];
			// console.log(this.cor_staff_code);
			if(opt && this.cor_amount && this.cor_staff_code.inputText)
				return this.correction_type.value==0?(opt+' '+this.cor_amount+' руб. '+this.cor_staff_code.inputText):(opt+' '+this.cor_amount+' руб. у '+this.cor_staff_code.inputText)
			return 'Корректировка'
		}
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			let sortOrder = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			if (!this.$GVO.isEmpty(this.objSortLoc)) {
				sortOrder = {'order_field':`${this.objSortLoc.order_field} ${this.objSortLoc.sortOrder==='descending'?'desc':'asc'}`}
			}

			this.$GVO.ApiCall('billing.GET_correction_history',{flt:{...filter, operation_type:'correct', /*...sortOrder,'staff_code':8023*/}})
			.then((objApi) => {
				if(objApi.success === true){
					this.CorrektirovkaApiData = [];
					this.masObjects_total = 0;

					if(objApi.data.length > 0){
						this.CorrektirovkaApiData = objApi.data;
						//this.masObjects_total = objApi.countpage;
					}
					if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
				}else{
					this.CorrektirovkaApiData = [];
					this.masObjects_total=0;
					this.objApimsg = objApi.msg;
				}
			}).catch(errorObjApi => {this.CorrektirovkaApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
			// this.getApiData();
		},
		onSortChange(objSort){
			this.$emit('sort', objSort);
			this.objSortLoc.order_field = this.$GVO.unlinkObject(objSort.prop);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(objSort.order);
			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("order_field", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				this.OnFilterApply();
			}
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('billing.GET_FILTER_CORRECTION',{})
				.then((objApi) => {
					if(objApi.success){
						//this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){ 
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);			
			this.getApiData();
		},
		onAgentChange(data){
			//this.objGetParams['code'] = data.selectedVal;
		},
		INS_CORRECT(){
			
			if(!String(this.correction_type.value)>'') return swal({
					title: 'Не выбран тип корректировки',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					text:`Укажите что хотите сделать: списание или пополнение`,
				});
			if(!String(this.cor_amount)>'') return swal({
					title: 'Не задана сумма корректировки',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					text:`Укажите сумму`,
				});				
			if(!String(this.cor_staff_code.selectedVal)>'') return swal({
					title: 'Не задан сотрудник',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					text:`Укажите сотрудника по которому происходит корректировка`,
				});				

			//console.log('staff_fio ' + this.cor_staff_code.inputText + ' amount = ' + this.cor_amount);
			this.$GVO.ApiCall('billing.INS_CORRECT',{'iData':{
			 	'amount':this.cor_amount,
			 	'comment':this.cor_comment,
			 	'staff_code': this.cor_staff_code.selectedVal,
			 	'staff_fio': this.cor_staff_code.inputText,
				'acc_user': this.$GVO.my_profile.code,
			 	'acc_user_fio': this.$GVO.my_profile.fio,
			 	'correction_type': this.correction_type.value,
			 }}).then((objApi) => {
				if(objApi.success){

					this.getApiData();

				}else {
					// alert('Не сохранилось. Возможно у вас нет доступа на изменение');
					// swal({
					// 	title: 'Ошибка корректировки',
					// 	buttonsStyling: false,
					// 	confirmButtonClass: 'btn btn-danger btn-fill',
					// 	text: `Нет доступа на внесение корректировок`,
						
					// });

					//this.$GVO.showAlert('Редактирование',objApi.msg); -- еще так можно вызывать алерт

					if(typeof objApi.ClientMsg == 'undefined')  {
						// alert(objApi.msg);
						swal({
							title: 'Ошибка корректировки',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-danger btn-fill',
							text:`${objApi.msg}`,
						});
					}else {
						swal({
							title: 'Ошибка корректировки',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-danger btn-fill',
							text:`${objApi.ClientMsg.msg}`,
						});
					}
				}
				this.cor_amount='';
				this.cor_comment='';
				this.correction_type.value = '';
				this.cor_staff_code={};
			}).catch(errorObjApi => console.error(errorObjApi));

			
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},

	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		if(typeof this.objGetParams.order_field != 'undefined'){
			this.objSortLoc.order_field = this.$GVO.unlinkObject(this.objGetParams.order_field);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
			this.$refs.CorrektirovkaTable.sort(this.objSortLoc.prop,this.objSortLoc.order);
		}
		this.getApiData();
		
	}
}
</script>
<style scoped>
.BillCorrection {position: relative;}
.BillCorrection .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
}
.BillCorrection .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.BillCorrection .clientPage .card-collapse .post {
	background: #27293d;
}
.BillCorrection .white-content .card:not(.card-white) .post {
	background: #fff;
}
.BillCorrection .postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.BillCorrection .post h5 {
	margin-bottom: 0px;
}
.BillCorrection .form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.col-title {display: flex; flex-direction: column;}
.BillCorrection >>> .el-table .cell {
    word-break: break-word;
}
</style>
